import { format, isValid, parseISO } from 'date-fns'

import { EMPTY_STRING } from '../../../constants/common'
import {
  CURRENCY_FORMAT_OPTIONS,
  CURRENCY_SYMBOL_MAP,
} from '../../../constants/currency'
import { DATE_SHORT_FORMAT } from '../../../constants/date'
import { formatNumberWithSeparators } from '../../../utils/number'

import { ProfileInfoFieldType } from './ProfileInfoWidget.constants'

export function isInfoSelectField(type) {
  return type === ProfileInfoFieldType.SELECT
}

export function isInfoCurrencyField(type) {
  return type === ProfileInfoFieldType.CURRENCY
}

export function isInfoPhoneField(type) {
  return type === ProfileInfoFieldType.PHONE
}

export function isInfoEmailField(type) {
  return type === ProfileInfoFieldType.EMAIL
}

export function isInfoDateField(type) {
  return type === ProfileInfoFieldType.DATE
}

export function hasInfoFieldVariables(fieldVariables) {
  return fieldVariables.length > 0
}

export function getInfoDateValue(rawValue) {
  const date = rawValue ? parseISO(rawValue) : null

  return date && isValid(date) ? date : null
}

export function formatInfoDate(rawValue) {
  const date = getInfoDateValue(rawValue)

  return date ? format(date, DATE_SHORT_FORMAT) : EMPTY_STRING
}

export function getInfoSelectLabel({ optionLabelKey = 'value', value }) {
  return value?.[optionLabelKey] ?? EMPTY_STRING
}

export function formatInfoMoney(value) {
  if (!value || value.amount == null) {
    return EMPTY_STRING
  }

  const amount = formatNumberWithSeparators(
    value.amount,
    CURRENCY_FORMAT_OPTIONS
  )
  const symbol =
    CURRENCY_SYMBOL_MAP[value.currency] ?? value.currency ?? EMPTY_STRING

  return symbol ? `${amount} ${symbol}` : amount
}
